<template>
  <div class="choose-box">
    <back-to-store class="back" v-if="isShowBack"></back-to-store>
    <div class="login-type">
      <div
        v-if="isUidLogin"
        class="login-type-btn uid j-click-login-way-uid"
        @click="handleUidLogin"
      >
        {{ letter.storeAccountIdLogin }}
      </div>
      <div
        v-if="isAccountLogin"
        class="login-type-btn j-click-login-way-account"
        @click="login"
      >
        {{ accountType ? letter.storeAccountIdLogin : letter.voucherLoginLook }}
      </div>
      <div
        v-if="isUidTokenLogin"
        class="login-type-btn uid-token j-click-login-way-uid-token"
        @click="handleUidTokenLogin"
      >
        {{ isJpPlatform ? letter.jpUidLoginName : letter.uidLoginName }}
      </div>
    </div>
    <p class="first-stored-tip">
      {{ letter.firstPayOff }}
    </p>
  </div>
</template>

<script>
import login from '@mixins/officialStore/login';
import BackToStore from '@components/officialStore/BackToStore.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'selectLoginWay',
  mixins: [login],
  computed: {
    ...mapGetters(['gameInfoConfig', 'isJpPlatform']),
    isUidLogin() {
      return this.gameInfoConfig.isUidLogin;
    },
    isAccountLogin() {
      return this.gameInfoConfig.isAccountLogin;
    },
    isUidTokenLogin() {
      return this.gameInfoConfig.isUidTokenLogin;
    },
    loginType() {
      return this.$store.getters.gameInfoConfig.loginType;
    },
    accountType() {
      return this.loginType === 'account';
    },
    isShowBack() {
      return this.$route.name !== 'home';
    }
  },
  components: {
    BackToStore
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.choose-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  background-size: cover;
  @psetbg ('choose-box.png');
  .back {
    margin-left: 48px;
    margin-bottom: 48px;
  }
  .login-type {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    color: var(--login-loginway-btn);
    &-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px auto;
      cursor: pointer;
      font-size: 30px;
      white-space: nowrap;
      @psetbg ('normal-login.png');
      &.uid {
        margin: 0 auto;
        @psetbg ('uid-login.png');
      }
      &.uid-token {
        margin: 0 auto;
        @psetbg ('uid-token-login.png');
      }
    }
  }
}
.first-stored-tip {
  margin: 20px 0 50px;
  font-size: 24px;
  color: #f0cb80;
  text-align: center;
}
@media screen and (orientation: landscape) {
  .choose-box {
    // 这里
    position: relative;
    @psetbg ('choose-box-hen.png');
  }
}
</style>
